import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Link } from 'react-router-dom';
import backendApi from "./BackendApi.js";
import { useTranslation } from 'react-i18next';

const EXTENSION_ID = "cdiccjpomhnpkkpbeaglcfnifbllklpg"; // ID dell'estensione

const LargeSquareButton = ({ icon, text, linkTo, newTab, onClick, children, showErrorFun }) => {
   const [t,i18n] = useTranslation("global");
  // Funzione per verificare se l'estensione è installata e impostare i cookie
  const handleCheckAndSetCookie = () => {

    let responded = false;
    console.log("handleCheckAndSetCookie");
    let lastVersion=2
    const listener = (event) => {
      if (event.data.action === "extension_status") {
        responded = true; // Segnaliamo che l'estensione ha risposto
        let isNotUpdated = (Number(lastVersion) - Number(event.data.version) > 0)
        if (!event.data.installed || !event.data.version  || isNotUpdated ) {
          showErrorFun(t("components.largeSquareButton.errors.generalCookiesError"));
        } else {
          setCookie(); // Se l'estensione è installata, imposta i cookie
        }
        window.removeEventListener("message", listener);
      }
    };

    window.addEventListener("message", listener);
    window.postMessage({ action: "check_extension" }, "*");

    // Timeout se non riceviamo risposta in 3 secondi
    setTimeout(() => {
      console.log("Timeout: "+JSON.stringify(responded))
      if (!responded) {
        showErrorFun(t("components.largeSquareButton.errors.missingWebExtension"));
        window.removeEventListener("message", listener);
      }
    }, 3000);
  };

  // Funzione per invocare l'API e settare i cookie
  const setCookie = async () => {
    try {
        const username = localStorage.getItem("email"); // Ottengo il nome utente dal localStorage"
        if (!username) {
          showErrorFun(t("components.largeSquareButton.errors.generalCookiesError"));
          return;
        }

      const response = await backendApi.get("api/set-cookie?username="+encodeURIComponent(username));

      //const response = await fetch(`https://stage.domino-design.it/domino/api/set-cookie?username=${encodeURIComponent(username)}`, {
      // method: 'GET', // Usa il metodo corretto
      // credentials: 'include', // Includi le credenziali
      //});

      if (response.status !== 200) {
        throw new Error("Errors on cookies!");
        //ti dovrebbe buttare fuori
      }

      const cookies = response.data;
      console.log("Cookie ricevuti dal backend:", cookies);

      if (!Array.isArray(cookies) || cookies.length === 0) {
        showErrorFun(t("components.largeSquareButton.errors.missingWebExtension"));
        return;
      }

      // Itera sui cookie ricevuti e li invia all'estensione
      cookies.forEach((cookie) => {
        window.postMessage(
          {
            action: "setCookie",
            cookieDetails: {
              url: "https://productionbackend.infurnia.com", // Imposta l'URL usando il dominio del cookie
              name: cookie.name,
              value: cookie.value,
              domain: cookie.domain,
              path: cookie.path,
              expires: cookie.expires, // Assumendo che sia già un numero (timestamp Unix)
              secure: cookie.secure,
              httpOnly: cookie.httpOnly,
              sameSite: cookie.sameSite,
            },
          },
          "*"
        );
      });

      navigateToLink(); // Procede con la navigazione dopo aver inviato i cookie

    } catch (error) {
      console.error("Errore:", error);
      showErrorFun(t("components.largeSquareButton.errors.generalCookiesError"));
    }

  };

  // Funzione per navigare al link specificato
  const navigateToLink = () => {
    if (linkTo) {
      if (newTab) {
        console.log("opening a new window from now");
        window.open(linkTo, "_blank"); // Apre il link in una nuova scheda
      } else {
        window.location.href = linkTo; // Naviga nella stessa finestra
      }
    }
  };

  //Funzione per gestire il click
  const handleClick = (e) => {
     console.log("handleClick");
     e.preventDefault(); // Preveniamo il comportamento di default del click
     handleCheckAndSetCookie(); // Verifica l'estensione prima di navigare
  };


  return (
    <div>
      <Link onClick={handleClick} className="large-button" >
          {icon && <span className="large-button_icon">{icon}</span>}
          {text && <span className="large-button_text">{text}</span>}
          {children} {/* Slot for custom markup */}
      </Link>
    </div>
  );
};

export default LargeSquareButton;